import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "mainMenuNavigationItem",
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  } // mounted goes here
  ,
  components: {
    // components go here
  },
  props: {
    // props go here
    breadcrumbs: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    menuItems: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    previousPage: {
      type: String,
      "default": ""
    }
  },
  data: function data() {
    return {
      // data goes here
    };
  },
  methods: {
    reAllowAppInstall: function reAllowAppInstall() {
      console.log("trying to allow app install");
      localStorage.setItem("pwaOptedOut", false);
      // refresh page
      if (this.$store.state.showMainApplication === true || this.$store.state.showMainApplication === 'true') {
        window.location.reload();
      }
    },
    launchWindow: function launchWindow(url) {
      if (url === "logout") {
        localStorage.removeItem("security");
        localStorage.clear();
        // reload page
        location.reload();
        return;
      }
      if (url) {
        window.location.href = url;
      }
    },
    breadCrumbClick: function breadCrumbClick(index, action) {
      this.$emit("breadCrumbClick", index, action);
    },
    menuItemClick: function menuItemClick(index, action) {
      this.$emit("menuItemClick", index, action);
    }
  }
});